// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"986c3e21","856":"986c3e21","929":"fee61089"}[chunkId] + ".chunk.css";
};